import { Vector as VectorSource } from 'ol/source';
import { Vector as VectorLayer } from 'ol/layer';
import { Geometry, Point } from 'ol/geom';
import { Icon, Style} from 'ol/style';
import { Feature } from 'ol';
import { fromLonLat } from 'ol/proj';
import { MapCoordinates } from '../../local_modules/voyage-vessel-spot-weather-control/src/voyage-vessel-spot-weather-control';

const _PROJECTION = (<any>window)["appenv"].projection;

export class SpotWeatherMarkerLayer extends EventTarget
{
    private _layer : VectorLayer<VectorSource<Geometry>> | null = null;
    private _coordinates: MapCoordinates | null = null;
    private _markerSvg = escape(`
    <svg width="17pt" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" height="17pt" viewBox="0 0 560 560" >
     <g transform="translate(-0.511702, 8e-07)" style="fill:#003D6D; fill-rule:evenodd; stroke:none; stroke-width:1; stroke-linecap:butt; stroke-linejoin:miter; stroke-dasharray:none;" >
      <path d="M560.512 0.570216 C560.512 2.05696 280.518 560.561 280.054 560 C278.498 558.116 0 0.430888 0.512416 0.22416 C0.847112 0.089136 63.9502 27.1769 140.742 60.4192 C140.742 60.4192 280.362 120.86 280.362 120.86 C280.362 120.86 419.756 60.4298 419.756 60.4298 C496.422 27.1934 559.456 0 559.831 0 C560.205 0 560.512 0.2566 560.512 0.570216 Z" />
     </g>
    </svg>
    `);
    
    get layers(): VectorLayer<VectorSource<Geometry>>[] {
        return this._layers;
    }

    async initialize(): Promise<void> {
        this._vectorSource = new VectorSource();
        this._layer = new VectorLayer({source: this._vectorSource, visible: false});
        this._layers.push(this._layer);
        this.plot();
    }

    setCoordinates(coordinates: MapCoordinates | null) {
        this._coordinates = coordinates;
        this._clear();
        this.plot();
    }

    private _clear() {
        try {
            this._vectorSource!.clear();
        } catch (error) {
            console.warn(error);
        }
    }

    enable() {
        this._clear();
        this.plot().then(() => this._layer!.setVisible(true));
    }

    disable() {
        if (this._layer) {
            this._layer.setVisible(false);
            this._clear();
        }
    }

    private _layers: VectorLayer<VectorSource<Geometry>>[] = [];
    private _vectorSource: VectorSource<Geometry>|null = null;

    public async plot() {
        this._clear();

        if (!this._coordinates) {
            return;
        }

        const markerStyle = new Style({
            image: new Icon({
                src: 'data:image/svg+xml;utf8,' + this._markerSvg,
                rotateWithView: true,
                anchor: [.5,1],
                scale: 1,
            }),
            zIndex: 20
        });

        const iconFeature = new Feature({
            geometry: new Point(fromLonLat([this._coordinates.x, this._coordinates.y], _PROJECTION)),
            name: `Spot weather reading - Lat: ${this._coordinates.lat} Lon: ${this._coordinates.lon}`,
        });
        
        iconFeature.setStyle(markerStyle);
        this._vectorSource!.addFeatures([iconFeature]);
    }
};
